// Import Vue and Vuex
import Vue from 'vue'
import Vuex from 'vuex'
// Import router
import router from '../router'

// Use Vuex APIs
Vue.use(Vuex)

// Responding actions
const actions = {
    goStatic(context, value){
        context.commit('GO_STATIC', value)
    },
    goPosition(context, value){
        context.commit('GO_POSITION', value)
    }
}

// Operating and updating data
const mutations = {
    // go to the static files
    GO_STATIC(state, value){
        window.open('/DonaldLamNL/static/' + value)
    },
    // go to the specified position
    GO_POSITION(state, {path, location = 0}){
        router.push({
            path,
            query: {
                location
            }
        })

    },
}

// Saving data
const state = {

}

// Create and expose store
export default new Vuex.Store({
    actions,
    mutations,
    state
})